const header = document.querySelector('.header');

if (header) {
    let headerTop = document.querySelector('.header__top');
    let headerTopNavigation = headerTop.querySelector('.header__top-navigation');
    let headerTopNavigationHeight;
    const headerBottom = document.querySelector('.header__bottom');
    const largeScreen = 1025;

    if (headerTopNavigation) {
        headerTopNavigationHeight = headerTopNavigation.clientHeight;
    }

    addMobileMenuPaddingBottom = () => {
        if (headerBottom && window.innerWidth < largeScreen) {
            headerBottom.style.paddingBottom = `${headerTopNavigationHeight + 180}px`;
        } else if (headerBottom) {
            headerBottom.removeAttribute('style');
        }
    };

    desktopScrollInteraction = () => {
        const body = document.body;
        const headerTopHeight = headerTop.clientHeight;
        const headerBottomHeight = headerBottom.clientHeight;

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 40)) {
            body.classList.add('header-fixed');
        } else {
            body.classList.remove('header-fixed');
        }

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 100)) {
            body.classList.add('transitions-on');
        } else {
            body.classList.remove('transitions-on');
        }

        if (window.pageYOffset > (headerTopHeight + headerBottomHeight + 450)) {
            headerBottom.classList.add('active');
        } else {
            headerBottom.classList.remove('active');
        }
    };

    addMobileMenuPaddingBottom();

    window.addEventListener("resize", () => {
        headerTop = document.querySelector('.header__top');
        headerTopNavigation = headerTop.querySelector('.header__top-navigation');

        if (headerTopNavigation) {
            headerTopNavigationHeight = headerTopNavigation.clientHeight;
        }

        addMobileMenuPaddingBottom();
    });

    window.addEventListener("scroll", function () {
        if (!headerBottom) {
            return false
        }

        desktopScrollInteraction();
    }, false);
}